// reducers/offerReducer.js
import { offerConstants } from "../actions/constants";

const initialState = {
  list: { items: [], total: 0, loading: false },
  current: {
    data: null,
    loading: false,
    saving: false,
    locking: {},      // { "items[0].price": { userId } }
    presence: {},     // { userId: "typing"/"join"/... }
    lastTotals: null,
    lastPdfUrl: null,
  },
};

export default function offerReducer(state = initialState, action) {
  switch (action.type) {
    // LIST
    case offerConstants.LIST_REQUEST:
      return {
        ...state,
        list: { ...state.list, loading: true },
      };

    case offerConstants.LIST_SUCCESS: {
      const { items, total } = action.payload;
      return {
        ...state,
        list: { items, total, loading: false },
      };
    }

    case offerConstants.LIST_FAILURE:
      return {
        ...state,
        list: { ...state.list, loading: false },
      };

    // ONE
    case offerConstants.GET_REQUEST:
      return {
        ...state,
        current: { ...state.current, loading: true, lastPdfUrl: null },
      };

    case offerConstants.GET_SUCCESS:
      return {
        ...state,
        current: { ...state.current, data: action.payload, loading: false },
      };

    case offerConstants.GET_FAILURE:
      return {
        ...state,
        current: { ...state.current, loading: false },
      };

    // CREATE
    case offerConstants.CREATE_SUCCESS:
      return {
        ...state,
        current: { ...state.current, data: action.payload },
      };

    // DELETE
    case offerConstants.DELETE_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          items: state.list.items.filter(i => i._id !== action.payload.offerId),
        },
      };

    // FINALIZE
    case offerConstants.FINALIZE_REQUEST:
      return {
        ...state,
        current: { ...state.current, saving: true },
      };

    case offerConstants.FINALIZE_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          saving: false,
          data: action.payload.offer,
          lastPdfUrl: action.payload.url,
        },
      };

    case offerConstants.FINALIZE_FAILURE:
      return {
        ...state,
        current: { ...state.current, saving: false },
      };

    // SOCKET
    case offerConstants.SOCKET_SNAPSHOT:
      return {
        ...state,
        current: { ...state.current, data: action.payload.doc },
      };

    case offerConstants.SOCKET_UPDATED: {
      const { patch, totals } = action.payload;
      const merged =
        state.current.data
          ? { ...state.current.data, ...patch, totals: totals || state.current.data.totals }
          : null;
      return {
        ...state,
        current: { ...state.current, data: merged, lastTotals: totals || null },
      };
    }

    case offerConstants.SOCKET_LOCKED: {
      const { field, userId } = action.payload;
      return {
        ...state,
        current: {
          ...state.current,
          locking: { ...state.current.locking, [field]: { userId } },
        },
      };
    }

    case offerConstants.SOCKET_UNLOCKED: {
      const { field } = action.payload;
      const next = { ...state.current.locking };
      delete next[field];
      return {
        ...state,
        current: { ...state.current, locking: next },
      };
    }

    case offerConstants.SOCKET_PRESENCE: {
      const { userId, state: pstate } = action.payload;
      return {
        ...state,
        current: {
          ...state.current,
          presence: { ...state.current.presence, [userId]: pstate },
        },
      };
    }

    default:
      return state; // важно — возвращаем прежнюю ссылку
  }
}
